import { render, staticRenderFns } from "./OdinPage.vue?vue&type=template&id=3d2ba8ae"
import script from "./OdinPage.vue?vue&type=script&lang=js"
export * from "./OdinPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports